import React from "react";
import classes from "./PlanDownsell.module.scss";
import cx from "classnames";

const planDownsell = (props) => (
  <div className={classes.PlanDownsell}>
    <div className={classes.title}>Looking for a smaller plan?</div>
    {props.planDownsellValuesSelected.slug !== "singleGame" ? (
      <>
        <div className={classes.benefits}>
          Learn more about the{" "}
          <strong>{props.planDownsellValuesSelected.plan}</strong>, which starts
          at just {props.planDownsellValuesSelected.priceRange}
        </div>
        <div
          className={cx(classes.blueButton, classes.button)}
          onClick={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                `Washington Nationals: Tickets: Nationals Ticketfinder: We Recommend: looking for a smaller plan? : switch to ${props.planDownsellValuesSelected["slug"]} plan button click`,
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: We Recommend",
                  prop14: `looking for a smaller plan? : switch to ${props.planDownsellValuesSelected["slug"]} plan button click`,
                }
              );
            }
            props.onClickChooseMyPlansToggle(
              props.planDownsellValuesSelected["slug"]
            );
          }}
        >
          Switch to <span>{props.planDownsellValuesSelected.plan}</span>
        </div>
      </>
    ) : (
      <>
        <div className={classes.benefits}>
          Learn more about{" "}
          <strong>{props.planDownsellValuesSelected.plan}</strong>, which start
          at just {props.planDownsellValuesSelected.priceRange}
        </div>
        <a
          href="https://www.mlb.com/nationals/tickets/single-game-tickets?intcmp=ticketfinder-singlegametickets"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={classes.button}>Select</div>
        </a>
      </>
    )}
  </div>
);

export default planDownsell;
